import React from "react";
import Hero from "../components/Hero";
import HeaderNav from "../components/HeaderNav";
import Footer from "../components/Footer";
import { Analytics } from "@vercel/analytics/react";

const Refund = () => {
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Analytics />
        <HeaderNav />
        <Hero>
          <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
            <div className="gap-3 flex">
              <span className="  text-white font-bold text-5xl">About Our</span>
              <span className="text-yellow-400 font-bold text-5xl">Refund</span>
            </div>
            <span className="text-yellow-400 font-bold text-5xl">Policy</span>
            <p className=" text-white font-normal text-xl w-2/3">
              Read carefully!
            </p>
          </div>
          <div className="flex flex-col px-5 md:px-10 py-5 gap-7 h-full phone justify-center z-50">
            <div className="flex gap-3 flex-wrap">
              <span className="text-white font-bold text-3xl sm:text-5xl md:w-screen">
                About Our
              </span>
              <span className=" text-yellow-400  font-bold text-3xl sm:text-5xl">
                Refund
              </span>
              <span className=" text-yellow-400 font-bold text-3xl sm:text-5xl ">
                Policy
              </span>
            </div>
            <p className=" text-white font-normal sm:text-xl ">
              Read carefully!
            </p>
          </div>
        </Hero>
        <div className="flex w-screen items-center justify-center">
          <text className=" px-10 py-10 flex text-justify">
            The information transmitted is intended only for the persons or
            entity above the age of 18. Green Luck Tips do not refund money paid
            for subscription and not liable to any money lost or gained.
            Countries that betting is not legal should not subscribe to our
            plans. You can read through Our Terms and Conditions for more
            information on Green Luck Tips.
          </text>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Refund;
